import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LogIn } from 'lucide-react';
import {
    AlertDialog,
    AlertDialogContent,
    AlertDialogHeader,
    AlertDialogTitle,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogAction,
} from './ui/alert-dialog';

/**
 * Shown when the session can no longer be refreshed (refresh token expired
 * or revoked). Explains why the user was signed out instead of leaving them
 * with cryptic per-page errors.
 */
export default function SessionExpiredDialog({ open, onLoginAgain }) {
    const navigate = useNavigate();

    const handleLogin = () => {
        onLoginAgain?.();
        navigate('/login', { replace: true });
    };

    return (
        <AlertDialog open={open}>
            <AlertDialogContent className="max-w-md">
                <AlertDialogHeader>
                    <div className="w-11 h-11 rounded-full bg-amber-100 flex items-center justify-center mb-2">
                        <LogIn className="w-5 h-5 text-amber-600" />
                    </div>
                    <AlertDialogTitle style={{ fontFamily: 'Manrope, sans-serif' }}>
                        You've been signed out
                    </AlertDialogTitle>
                    <AlertDialogDescription>
                        Your session expired after a long period of inactivity, so we signed
                        you out to keep your account secure. Log in again to pick up where
                        you left off.
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogAction onClick={handleLogin} className="bg-stone-900 hover:bg-stone-800">
                        Log in again
                    </AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
}
